
import { IProfileWebsite, IWebsitePage } from "../../../services";
import { Utils } from "../../../utils";

export type MemberPage = keyof IProfileWebsite["website_pages"];

export function pagePath(basePath: string, page: string) {
    return `/${basePath}${page === "HOME" ? "" : "/" + page.toLowerCase()}`;
}

export function visiblePages(website: IProfileWebsite): [string, IWebsitePage][] {
    return Utils.entriesInCustomOrder(website.website_pages as any).filter(([_, pageSettings]) => pageSettings.visible);
}

export function isPageVisible(website: IProfileWebsite, page: MemberPage) {
    return !!website.website_pages?.[page]?.visible;
}

export function splitName(name: string) {
    const parts = (name ?? "").trim().split(/\s+/);
    if (parts.length < 2) return { first: "", last: parts[0] ?? "" };
    return { first: parts.slice(0, -1).join(" "), last: parts[parts.length - 1] };
}

export function activeMedia(website: IProfileWebsite, key: keyof IProfileWebsite["media"]): string | undefined {
    const media = website.media?.[key];
    if (!media?.length) return undefined;
    return media[website.extra_data?.media?.[key]?.active ?? 0] ?? media[0];
}
